import { render, staticRenderFns } from "./AddFeeDetails.vue?vue&type=template&id=bf719cb6&"
import script from "./AddFeeDetails.vue?vue&type=script&lang=js&"
export * from "./AddFeeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports